// @flow

/* eslint-disable react/jsx-no-bind */

import * as React from 'react';
import { QueryRenderer, graphql } from 'react-relay/compat';
import Environment from 'app/lib/relay/environment';
import SectionLoader from 'app/components/shared/SectionLoader';
import JobActivityTimelineList from './JobActivityTimelineList';
import './styles.css';

import type { JobActivityTimelineQueryResponse } from './__generated__/JobActivityTimelineQuery.graphql';

type Props = {|
  job: {
    id: string
  }
|};

export default class JobActivityTimeline extends React.PureComponent<Props> {
  environment = Environment.get();

  static query = graphql`
    query JobActivityTimelineQuery($id: ID!) {
      job(uuid: $id) {
        ...JobActivityTimelineList_job
      }
    }
  `;

  render() {
    return (
      <QueryRenderer
        dataFrom="STORE_THEN_NETWORK"
        environment={this.environment}
        query={JobActivityTimeline.query}
        variables={{ id: this.props.job.id }}
        render={({ error, props }: {error: ?Error, props: JobActivityTimelineQueryResponse}) => {
          if (error) {
            return null; // TODO: Handle this!
          }

          if (!props) {
            return <SectionLoader />;
          }

          return <JobActivityTimelineList {...props} />;
        }}
      />
    );
  }
}



